import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../core/actions/actions';
import './Sensor.css';
import { FormattedMessage } from 'react-intl';
import { formatMessage } from '../../translations/connectedIntlProvider';
import AddSensorFilter from './AddSensorFilter';
import { ButtonFormatter } from '../../shared/components/Grid/GridFormatter';
import Loader from '../../shared/components/Loader/Loader';
import Grid from '../../shared/components/Grid/Grid';
import IState from '../../core/models/IState';
import { allSensors } from '../../core/selectors/sensor.selector';
import { faTrashAlt, faDatabase, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import AddSensorPopupHOC from './hoc/AddSensorPopupHOC';
import AddSensor from './AddSensor';
import DeletePopup from '../../shared/components/Popup/DeletePopup';
import { toast } from 'react-toastify';
import DeletePopupHOC from '../../shared/components/Popup/hoc/DeletePopupHOC';
import RoutesConstants from '../../shared/components/Routes/routes.constants';
import NoDataFoundPopup from '../../shared/components/NoDataFoundPopup/NoDataFoundPopup';
import NoDataFoundPopupHOC from '../../shared/components/NoDataFoundPopup/hoc/NoDataFoundPopupHOC';
import Pagination from "../../shared/components/Grid/Pagination";
import IPageInfo from '../../models/IPageInfo';
import AddSensorFilterPopupHOC from './hoc/AddSensorFilterPopupHOC';
import DownloadSensorPopupHOC from './hoc/DownloadSensorPopupHOC';
import DownloadSensor from './DownloadSensor';
import sensorIcon from '../../assets/Images/sensor32.png';
import IPageLimit from '../../models/IPageLimit';
import { injectIntl } from 'react-intl';
import useWindowDimensions from '../../helpers/windowResize.helper';
import { reset } from 'redux-form';
import QRCodeScannerPopupHOC from './hoc/QrCodeScannerPopupHOC';
import QRCodeScanner from './components/QRCodeScanner';
import DownlinkTest from './DownlinkTest';
import DownlinkTestPopupHOC from './hoc/DownlinkTestPopupHOC';
import DeviceState from './DeviceState';
import DeviceStatePopupHOC from './hoc/DeviceStatePopupHOC';
import modelEnum from '../../constants/model.enum';
import DeviceAccessPopupHOC from './hoc/DeviceAccessPopupHOC';
import DeviceAccess from './DeviceAccess';
import NoDataComponent from '../../shared/components/NoData/NoDataComponent';
import SensorIcon from '../../assets/Images/icon/svg/sensor-icon.svg'
import { convertLocalToUTC } from '../../constants/common.constant';
import sensorType from '../../core/types/sensor.type';

const Sensor = (props: any) => {
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const pager: IPageLimit = useSelector((state: IState) => { return state.pager });
  const language = useSelector((state: IState) => { return state.preferences.language });
  const { userType }: any = useSelector((state: IState) => { return state.auth });
  const allSensorsData: any = useSelector(allSensors);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedICCID, setSelectedICCID] = useState<string>('');
  const [selectedModel, setSelectedModel] = useState<string>('');
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [qrCodeScanning, setQRCodeScanning] = useState<boolean>(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false
  });
  const [showDeviceAccessIcon, setShowDeviceAccessIcon] = useState<boolean>(false)
  const dispatch = useDispatch();
  const { sensorList, deleteSensor, addSensor, sensor }: any = useSelector((state: IState) => { return state.sensor });

  let paginationData: any = {
    CurrentPage: 1,
    PageSize: 10,
    OrderBy: 'desc',
    SensorLocationParam: null
  }

  const { height, width } = useWindowDimensions();

  var windowHeight = width > 767 ? {
    maxHeight: height - 80
  } : {
    maxHeight: height - 125
  };

  //let hasFilter = null;
  const [hasFilter, setHasFilter] = useState<boolean>(false);


  let val = {
    CurrentPage: 1,
    PageSize: 10,
    OrderBy: 'desc',
    SensorLocationParam: {
      ICCID: '',
      CustomerId: '',
      Building: '',
      Floor: '',
      Room: '',
      Location: '',
      SensorType:modelEnum.IAQ.toLowerCase()

    }
  }


  const onClearFilter = () => {
    setHasFilter(false)
    val.CurrentPage = 1;
    val.PageSize = pager.pageLimit;
    localStorage.removeItem('SensonLocation.Filter');
    dispatch(actions.getAllSensor(val));
    dispatch(actions.resetAddSensorState())
    dispatch(actions.resetGetSensorByIdState())
    dispatch(reset('AddSensorFilterForm'));
  }





  // const setHasFilter = ()=>{
  //   hasFilter = JSON.stringify(localStorage.getItem('SensonLocation.Filter'));
  // }

  // useEffect(() => {
  //   hasFilter = JSON.stringify(localStorage.getItem('SensonLocation.Filter'));
  //   console.log(hasFilter);
  // }, hasFilter);


  const openAddSensorHandler = (row: any, isDeleteParam: boolean) => {
    setQRCodeScanning(false);
    setSelectedId(row.id);
    setSelectedICCID(row.ICCID);
    setSelectedModel(row.Model);
    setIsDelete(isDeleteParam);
    props.addSensorToggleHandler();
  }

  const openQRCodeScannerHandler = () => {
    // if (window.location.protocol=="http:")
    //   toast.error(formatMessage("QR_Code_does_not_work_with_http_protocol"));
    // else
    // {
    setQRCodeScanning(true);
    props.QRCodeScannerToggleHandler();
    //}
  }

  const openAddSensorFilterHandler = (row: any, isDeleteParam: boolean) => {
    setSelectedId(row.id);
    setSelectedICCID(row.ICCID);

    setIsDelete(isDeleteParam);
    props.addSensorFilterToggleHandler();
  }

  const deleteHandler = () => {
    if (selectedModel === modelEnum.IAQ.toLowerCase())
      dispatch(actions.deleteIAQSensor(selectedICCID, userType.toString() === 'Administrator'));
    else
      dispatch(actions.deleteSensor(selectedICCID));

  }

  const deleteClickHandler = (row: any) => {
    setSelectedId(row.id);
    setSelectedICCID(row.ICCID);
    setSelectedModel(row.Model);
    props.deletePopupToggleHandler();
  }

  const redirectClickHandler = (row: any) => {
    if (row.Model === undefined || row.Model === null) {
      dispatch(actions.resetGetSensorByIdState());
      props.noDataFoundPopupToggleHandler();
    } else {
      props.history.push({
        pathname: row.Model === modelEnum.IAQ.toLowerCase() ? RoutesConstants.IAQRealTimeView : RoutesConstants.SensorData,
        state: {
          iccid: row.ICCID,
          model: row.Model,
          building: row.Building,
          location: row.Location,
          floor: row.Floor,
          customerId: row.CustomerId,
          room: row.Room,
          latestPayloadTime: row.LatestPayloadTime,
          fromParentPath: RoutesConstants.Sensor
        }
      });
    }
  }

  // const QRCodeModalClosed = () =>{
  //   //setQRCodeScanning(false);
  //   props.QRCodeScannerToggleHandler();
  // }

  const QrCodeSubmitHandler = (scannedICCID: string) => {
    if (scannedICCID !== '' && scannedICCID !== undefined) {
      dispatch(actions.getSensorById(scannedICCID));
    }
  }

  useEffect(() => {
    if (sensor.sensor != null && sensor.loading == false && qrCodeScanning == true) {
      setQRCodeScanning(false);
      if (sensor.sensor) {
        sensor.sensor.CustomerId = sensor.sensor.CustomerID;
        redirectClickHandler(sensor.sensor);
      }
      else
        toast.error(formatMessage("Invalid_ICCID"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sensor.loading])

  useEffect(() => {
    if (sensor.error != null) {
      toast.error(formatMessage("Invalid_ICCID"));
      dispatch(actions.resetGetSensorByIdState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sensor.error]);

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    let pageSize = +evt.target.value;
    pages = props.data && Math.ceil(props.data.length / pageSize)
    setPageInfo({ ...pageInfo, currentPage: 1, totalPages: pages, isPagerChange: false });
    dispatch(actions.updatePagerPageLimit(pageSize));
  }

  const onPageChanged = (pageNumber: number) => {
    if (pageInfo.totalPages) {
      setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
    } else {
      setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true, totalPages: 1 });
    }
  }

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  }

  const downloadSensorClickHandler = () => {
    props.downloadSensorToggleHandler();
  }

  const downlinkTestClickHandler = () => {
    props.downlinkTestToggleHandler();
  }

  const deviceStateClickHandler = () => {
    props.deviceStateToggleHandler();
  }
  const refreshSensorClickHandler = () => {
    if (pager.isPageLimitLoaded) {
      GetAllSensors();
    }
  }

  const GetAllSensors = () => {
    paginationData.CurrentPage = pageInfo.currentPage;
    paginationData.PageSize = pager.pageLimit;
    setDisablePagination(true);
    let localStorageValue = localStorage.getItem('SensonLocation.Filter')!;
    var value = JSON.parse(localStorageValue);
    if (value) {
      // let tempSensorType: number = parseInt(value.SensorType);
      // value.SensorType = tempSensorType > -1 ? (tempSensorType === 0 ? modelEnum.IAQ.toLowerCase() : "other") : "";
      value.SensorType = modelEnum.IAQ.toLowerCase(); //Fixed type for sensor iaq
      setHasFilter(true);
      paginationData.SensorLocationParam = {
        ...value, LatestPayloadStartDateTime: value.LatestPayloadStartDateTime || null,
        LatestPayloadEndDateTime: value.LatestPayloadEndDateTime || null
      };
    }
    if (paginationData.SensorLocationParam && paginationData.SensorLocationParam?.SensorType && (paginationData.SensorLocationParam?.SensorType === modelEnum.IAQ.toLowerCase())){
      let tempSensorLocationParams = {...paginationData.SensorLocationParam}
      dispatch(actions.getAllSensorFromIAQAervice({...paginationData,SensorLocationParam: 
            {...tempSensorLocationParams, LatestPayloadStartDateTime: convertLocalToUTC(tempSensorLocationParams.LatestPayloadStartDateTime),
              LatestPayloadEndDateTime: convertLocalToUTC(tempSensorLocationParams.LatestPayloadEndDateTime)
            } }));
    }
    else
      dispatch(actions.getAllSensor({...paginationData, SensorLocationParam:{sensorType: modelEnum.IAQ.toLowerCase()}}));
    //setHasFilter(JSON.stringify(localStorage.getItem('SensonLocation.Filter')));
  }

  useEffect(() => {
    if (pager.isPageLimitLoaded) {
      GetAllSensors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pager.isPageLimitLoaded, pager.pageLimit]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      GetAllSensors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    refreshSensorClickHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  useEffect(() => {
    if (!sensorList.loading && sensorList.sensors.SensorLocations !== undefined && sensorList.sensors.SensorLocations.length >= 0) {
      setPageInfo({ ...pageInfo, totalPages: sensorList.sensors.TotalPages, isRefreshPage: sensorList.sensors.CurrentPage === 1 ? true : false });

      // pager.pageLimit = sensorList.sensors.PageSize;

      setDisablePagination(false);
      //setPageInfo({ ...pageInfo, isRefreshPage: false });

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sensorList.loading])

  useEffect(() => {
    if (addSensor.success) {
      GetAllSensors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addSensor.success]);

  useEffect(() => {
    if (deleteSensor.success) {
      toast.success(formatMessage('Message_Sensor_Delete_Success'));
      dispatch(actions.resetDeleteSensorState());
      setSelectedModel("");
      props.deletePopupToggleHandler();
      GetAllSensors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteSensor.success]);

  useEffect(() => {
    if (deleteSensor.error != null) {
      toast.error(formatMessage(deleteSensor.error));
      dispatch(actions.resetDeleteSensorState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteSensor.error]);

  useEffect(() => {
    let localStorageValue = localStorage.getItem('SensonLocation.Filter')!;
    dispatch(actions.resetUserSettingState());
    var value = JSON.parse(localStorageValue);
    if (value) {
      setHasFilter(true);
    }
    dispatch(actions.getPageLimit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (sensorList.error != null)
      toast.error(formatMessage(sensorList.error));
  }, [sensorList.error]);

  useEffect(() => {
    let isAdmin = localStorage.getItem('userType') === 'Administrator'
    setShowDeviceAccessIcon(isAdmin)
  }, [])

  const columns: any[] = [{
    dataField: 'id',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'Model',
    text: formatMessage('Label_ID'),
    hidden: true
  },
  {
    dataField: 'ICCID',
    text: formatMessage('Sensor_Table_Col_ICCID'),
    headerClasses: 'iccid-col'
  },
  {
    dataField: 'CustomerId',
    text: formatMessage('Sensor_Table_Col_CustomerId')
  },
  {
    dataField: 'Model',
    text: formatMessage('Sensor_type')
  },
  {
    dataField: 'Building',
    text: formatMessage('Sensor_Table_Col_Building')
  },
  {
    dataField: 'Floor',
    text: formatMessage('Sensor_Table_Col_Floor')
  }, {
    dataField: 'Room',
    text: formatMessage('Sensor_Table_Col_Room')
  },
  {
    dataField: 'Location',
    text: formatMessage('Sensor_Table_Col_Location')
  },
  {
    dataField: 'LatestPayloadTime',
    text: formatMessage('Latest_payload_time')
  },
  {
    dataField: 'Comments',
    text: formatMessage('Sensor_Table_Col_Comment')
  },
  {
    dataField: 'User',
    text: formatMessage('User_Title')
  },
  {
    dataField: 'edit',
    // text: <FormattedMessage id='Table_Col_Edit' />,
    //formatter: EditFormatter(openAddSensorHandler, faEdit, false, formatMessage('Edit'))
    formatter: ButtonFormatter(openAddSensorHandler, faPencilAlt, true, formatMessage('Edit')),
    text: ''
  }, {
    dataField: 'delete',
    // text: <FormattedMessage id='Table_Col_Delete' />,
    formatter: ButtonFormatter(deleteClickHandler, faTrashAlt, true, formatMessage('Delete')),
    text: ''
  },
  {
    dataField: 'data',
    // text: <FormattedMessage id='Table_Col_Data' />,
    formatter: ButtonFormatter(redirectClickHandler, faDatabase, false, formatMessage('Data')),
    text: ''
  },
    /*  {
       dataField: 'downlaod',
       text: <FormattedMessage id='Table_Col_Download' />,
       formatter: ButtonFormatter(downloadSensorClickHandler, faDownload, false)
     }];
    */
  ];

  const setHasFilterFun = (values: any) => {
    if (values === "")
      setHasFilter(false);
    else
      setHasFilter(true);
  }

  return (
    <React.Fragment>
      {
        props.showAddSensorFilterPopup &&
        <AddSensorFilter
          id={selectedId}
          isDelete={isDelete}
          iccid={selectedICCID}
          pageInfo={pageInfo}
          pager={pager}
          setHasFilterFun={setHasFilterFun}
          modalClosed={props.addSensorFilterToggleHandler} />
      }
      {
        props.showQRCodeScannerPopup &&
        <QRCodeScanner
          QrCodeSubmitHandler={QrCodeSubmitHandler}
          modalClosed={props.QRCodeScannerToggleHandler} />
      }
      {
        props.showAddSensorPopup &&
        <AddSensor
          id={selectedId}
          isDelete={isDelete}
          iccid={selectedICCID}
          model={selectedModel}
          modalClosed={props.addSensorToggleHandler}
        />

      }
      {
        props.showDeletePopup &&
        <DeletePopup
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          isLoading={deleteSensor.loading} />
      }

      {
        props.showNoDataFoundPopup &&
        <NoDataFoundPopup
          modalClosed={props.noDataFoundPopupToggleHandler} />
      }

      {
        props.showDownloadSensorPopup &&
        <DownloadSensor
          id={selectedId}
          modalClosed={props.downloadSensorToggleHandler}
        />
      }

      {
        props.showDownlinkTestPopup &&
        <DownlinkTest
          modalClosed={props.downlinkTestToggleHandler}
        />
      }

      {
        props.showDeviceStatePopup &&
        <DeviceState
          modalClosed={props.deviceStateToggleHandler}
        />
      }
      {
        props.showDeviceAccessPopup && (
          <DeviceAccess modalClosed={props.deviceAccessToggleHandler} isLoading={true} />
        )
      }
      <div className="icon-nav navbar-fixed-top device-nav-bar">
        <div className="container-fluid">
          <div className="filter-left-area">
            <ul>
              <li><h1><img src={sensorIcon} alt=""></img> <FormattedMessage id='Sensor_Title' /></h1></li>
            </ul>
          </div>

          <div className="add-list float-right">
            <ul>
              {showDeviceAccessIcon && (
                <li title={formatMessage('Device_Access')} className="mr-1">
                  <a
                    data-toggle="modal"
                    onClick={() => props.deviceAccessToggleHandler()}
                    data-target="#deviceAccess"
                  >
                    <svg
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      viewBox="0 0 24 24"
                    >
                      <circle cx="9" cy="6" r="3" />
                      <path d="M3 20c0-3.5 2.5-6 6-6s6 2.5 6 6" />
                      <circle cx="19" cy="11" r="2.5" />
                      <path d="M21.5 13.5l1.5 1.5-2 2" />
                      <path d="M20.5 15.5l-1 1" />
                    </svg>
                  </a>
                </li>
              )}
              {/*<li title={formatMessage('Downlink_Test')}>
                <a data-toggle="modal" onClick={() => downlinkTestClickHandler()} data-target="#addSensor">
                  <svg width="16" height="16" fill="currentColor" className="bi bi-cloud-upload mr-2" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z" />
                    <path fillRule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z" />
                  </svg>
                </a>
              </li>*/}
              {/*<li title={formatMessage('Device_State')}>
                <a data-toggle="modal" onClick={() => deviceStateClickHandler()} data-target="#addSensor">
                  <svg width="16" height="16" fill="currentColor" className="bi bi-cloud-download mr-2" viewBox="0 0 16 16">
                    <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z" />
                    <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708l3 3z" />
                  </svg>
                </a>
              </li>*/}
              <li title={formatMessage('QR_Code_Scanner')}>
                <a data-toggle="modal" onClick={() => openQRCodeScannerHandler()} data-target="#addSensor">
                  <svg width="16" height="16" fill="currentColor" className="bi bi-qr-code-scan" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3Zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5ZM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5ZM3 3h3v3H3V3Zm0 7h3v3H3v-3Zm7-7h3v3h-3V3ZM7 2H2v5h5V2Zm0 7H2v5h5V9Zm2-7h5v5H9V2ZM4 4h1v1H4V4Zm7 0h1v1h-1V4Zm-6 7H4v1h1v-1Zm3.5-3H8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8H8.5Zm1.5 2V9H9v1h1Zm4 3.5V12h-1v1h-2v1h3v-.5Zm-4 .5v-1H8v1h2Zm2-5h2V8h-2v1Z" />
                  </svg>
                </a>
              </li>
              <li title={formatMessage('Add_Sesnor')}>
                <a data-toggle="modal" onClick={() => openAddSensorHandler({ id: -1, iccid: '' }, false)} data-target="#addSensor">
                  <svg width="23" height="23" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                </a>
              </li>
              <li title={formatMessage('Filter')}>
                <a data-toggle="modal" onClick={() => openAddSensorFilterHandler({ id: -1, iccid: '' }, false)} data-target="#addSensorFilter">
                  <svg width="15" height="15" fill="#747474" className="bi bi-funnel" viewBox="0 0 16 16">
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
                  </svg>
                </a>
              </li>
              {
                hasFilter &&  //TODO: Change Icon and call Clear Filter Functionality
                <li title={formatMessage('Button_Clear_Filter')}>
                  <a data-toggle="modal" onClick={onClearFilter} data-target="#addSensor">
                    <svg width="15" height="15" fill="#747474" className="clearfilter" viewBox="0 0 100.000000 100.000000"
                      preserveAspectRatio="xMidYMid meet">
                      <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" stroke="none">
                        <path d="M7 993 c-4 -3 -7 -23 -7 -43 0 -34 13 -51 158 -205 l157 -168 5 -185 5 -186 107 -64 c59 -35 112 -61 117 -57 7 4 11 89 11 248 l1 242 160 169 c157 167 160 170 157 210 l-3 41 -431 3 c-237 1 -434 -1 -437 -5z m831 -52 c-2 -11 -70 -91 -153 -179 l-150 -161 -95 0 -95 0 -150 161 c-82 88 -151 168 -153 179 -3 18 9 19 398 19 389 0 401 -1 398 -19z m-318 -591 c0 -116 -2 -210 -5 -210 -2 0 -38 21 -80 46 l-75 45 0 165 0 164 80 0 80 0 0 -210z" />
                        <path d="M644 349 c-4 -6 28 -45 72 -90 l79 -79 -80 -80 c-63 -63 -77 -82 -67 -92 10 -10 29 4 92 67 l80 80 80 -80 c63 -63 82 -77 92 -67 10 10 -4 29 -67 92 l-80 80 80 80 c63 63 77 82 67 92 -10 10 -29 -4 -92 -67 l-80 -80 -78 78 c-42 42 -80 77 -84 77 -4 0 -10 -5 -14 -11z" />
                      </g>
                    </svg>
                  </a>
                </li>

              }
              {/*<li title={formatMessage('Download')}>
                <a data-toggle="modal" onClick={() => downloadSensorClickHandler()} data-target="#addSensorFilter">
                  <svg width="18" height="18" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                  </svg>
                </a>
              </li>*/}
              <li title={formatMessage('Refresh')}>
                <a data-toggle="modal" onClick={() => refreshSensorClickHandler()}>
                  <svg width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                  </svg>
                </a>
              </li>
              <li className="page-number">
                <Pagination isRefreshPage={pageInfo.isRefreshPage} totalPages={pageInfo.totalPages} pageLimit={pager.pageLimit} onPageChanged={onPageChanged} disablePagination={disablePagination} setIsRefreshPage={setIsRefreshPage} />
              </li>
              <li className="page-count-no">
                <select className='pageLimit' onChange={onPageLimitChanged} value={pager.pageLimit}>
                  {pager.pageLimitOptions.map((op: any) => <option key={op} value={op}>{op}</option>)}
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="device-detail">
        <div className="table-responsive" style={windowHeight}>
          {sensorList.loading ? <Loader /> : allSensorsData.length === 0 ?
            <NoDataComponent image={SensorIcon} message={'No_Sensor_Available'}
              imageAlt='No Sensor' subHeading={hasFilter ? 'Please_Remove_Filter' : null} /> :
            <Grid data={allSensorsData} columns={columns} keyField="id" />
          }
        </div>
      </div>

    </React.Fragment>
  )
};

export default injectIntl(DeviceStatePopupHOC(DownlinkTestPopupHOC(QRCodeScannerPopupHOC(AddSensorPopupHOC(DeletePopupHOC(NoDataFoundPopupHOC(AddSensorFilterPopupHOC(DownloadSensorPopupHOC(DeviceAccessPopupHOC(Sensor))))))))));